<template>
  <div v-if="!loading">
    <TextFormGroup
        v-model="data.headline"
        name="headline"
        label="Headline"
        :error="(errors.headline || [])[0]"
    />

    <TextFormGroup
        v-model="data.text"
        name="text"
        label="Text"
        :error="(errors.text || [])[0]"
    />

    <SelectFormGroup
        v-model="data.publication_based_channel_id"
        name="publication_based_channel_id"
        label="Publication Based Channel"
        :error="(errors.publication_based_channel_id || [])[0]"
        :options="publicationBasedChannelOptions"
    />
  </div>
</template>

<script>
import http from '@/http'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {SelectFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      publicationBasedChannels: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    },

    publicationBasedChannelOptions() {
      return this.publicationBasedChannels.map(publicationBasedChannel => ({
        value: publicationBasedChannel.id,
        label: publicationBasedChannel.attributes.name
      }))
    }
  },

  methods: {
    load() {
      http.get('/api/v2/publication-based-channels', {'filter[portal_id]': this.portal.id}).then(response => {
        this.publicationBasedChannels = response.data.data

        this.loading = false
      })
    }
  }
}
</script>
